export default "__VITE_ASSET__DVKlnLLH__"